import { ReactNode } from 'react'
import { Stack } from '@mui/material'

import ChargingSessionImage from './ChargingSessionImage'
import ChargingSessionMessage from './ChargingSessionMessage'

interface ChargingSessionBodyProps {
  message?: string | ReactNode
}

const ChargingSessionBody: React.FC<ChargingSessionBodyProps> = ({ message }) => {
  return (
    <Stack width="100%" alignItems="center" justifyContent="center" gap={3}>
      {message && <ChargingSessionMessage message={message} />}
      <ChargingSessionImage />
    </Stack>
  )
}

export default ChargingSessionBody
